
import { NgModule } from '@angular/core';

import { ProjectsRoutingModule } from './projects-routing.module';


@NgModule({
  imports: [
    ProjectsRoutingModule,
  ],
})
export class ProjectsModule { }
